/* eslint-disable @typescript-eslint/no-explicit-any */

import { URLParameters } from '@/app/common/urlParameters.ts';
import type { CommonData } from '@/app/common/createCommonData.ts';
import { Analytics } from './Analytics';
import { PlatformEnum } from './Analytics/utils/PlatformEnum';
import type { CuriosityParams } from './index';
import { getMarket } from './utils';
import type { Localization } from '../common/Localization';
import type { HotelImagesParams } from './Analytics/utils';
import type { HotelImageActionTypeEnum } from './Analytics/utils/HotelImageActionTypeEnum';
import type { DealCard } from '../utils/buildDealCards/dealCardTypes';
import getSearchParams from '../common/getSearchParams';

type HotelImagesEvent = {
  actionType: HotelImageActionTypeEnum;
  dealCard: DealCard;
  imageIndex: number;
  commonData: CommonData;
  localization: Localization;
  curiosityParams: CuriosityParams;
  AbortController: any;
};

const hotelImagesEvent = ({
  actionType,
  dealCard,
  imageIndex,
  commonData,
  localization,
  curiosityParams,
  AbortController,
}: HotelImagesEvent): void => {
  const { brand, country } = localization;
  const { isApp } = commonData;
  const searchParams = getSearchParams();
  const platform = isApp ? PlatformEnum.APP : PlatformEnum.TSX;
  const imageUrl = dealCard?.product?.accommodation?.gallery?.[imageIndex - 1] || '';
  const hotelId = dealCard?.product?.accommodation?.hotelId;
  const hotelCityId = dealCard?.product?.geo?.internalIdCity;
  const nights = dealCard?.product?.dates?.nights || 1;
  const offerPriceTotal = dealCard?.product?.rate?.price?.total?.price;
  const promotionList: string[] = [];
  if (dealCard?.product?.promotions?.flashSale) {
    promotionList.push('1');
  }
  if (dealCard?.product?.rate?.flags?.myPrice) {
    promotionList.push('2');
  }
  const promotions = promotionList.join(',');

  const analytics = new Analytics({
    market: getMarket(country),
    platform,
    commonData,
    curiosityParams,
    localization,
    brand,
    searchId: searchParams?.[URLParameters.SEARCH_ID],
    AbortController,
    isServer: false,
  });
  const hotelImagesParams: HotelImagesParams = {
    url: imageUrl,
    hotel_id: hotelId,
    hotel_city_id: hotelCityId,
    action_type: actionType,
    swipe_index: imageIndex,
    nights,
    offer_price_total: offerPriceTotal,
    promotions,
  };

  try {
    analytics.hotelImages(hotelImagesParams);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }
};

export default hotelImagesEvent;
